import type { TDisconnectedStatus } from "../internetConnection.t";
import { CONNECTION_STATUS_NAMES } from "../internetConnectionConstants";

const getConnectionStatusText = (status: TDisconnectedStatus) => {
    switch (status) {
        case CONNECTION_STATUS_NAMES.DISCONNECTED:
            return 'error.connection.lost';
        case CONNECTION_STATUS_NAMES.CONNECTING:
            return 'internet.connection.checking';
        default:
            return 'internet.connection.restored';
    }
}

export default getConnectionStatusText;
